import _ from 'lodash';
import React from 'react';
import { Tag, Text } from 'src/@vymo/ui/atoms';
import { format as formatDate } from 'date-fns';
import { parseJSON } from 'src/workspace/utils';

const getDisplayValue = (value) => {
  if (typeof value === 'string') {
    const parsedValue = parseJSON(value);

    return parsedValue ? getDisplayValue(parsedValue) : value;
  }
  if (Array.isArray(value)) {
    const displayValues = value
      .map((item) => getDisplayValue(item))
      .filter((item) => item && item !== '-');

    return displayValues.length ? displayValues.join(', ') : '-';
  }
  if (typeof value === 'object') return value?.name || '-';
  return JSON.stringify(value);
};

export const getCellView = (value, input) => {
  let dateFormat = input?.format;
  if (_.isNil(value)) return <Text>-</Text>;
  switch (input?.type) {
    case 'date':
      dateFormat = dateFormat || 'dd MMM yyyy';
      return <Text>{formatDate(value, dateFormat)}</Text>;
    case 'date_range_v2':
      dateFormat = dateFormat || 'MMMM d, yyyy h:mm aa';
      return <Text>{formatDate(value, dateFormat)}</Text>;
    case 'code_name_spinner':
    case 'multi_select_auto_complete':
      return <Tag label={getDisplayValue(value)} />;
    case 'text':
    default:
      return <Text>{getDisplayValue(value)}</Text>;
  }
};
